var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
  'card',
  'content-card',
  'shadow',
  _vm.data.class,
  _vm.data.staticClass
]},[_c('div',{staticClass:"card-body p-4"},[_vm._t("title",function(){return [(_vm.props.title)?_c('h4',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.props.title))]):_vm._e()]}),_c('div',{staticClass:"card-text"},[_vm._t("default")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }